import http from '../httpService';

const CriminalAntecedentService = {
  criminalAntecedentsRetryService: params => http.post('criminal-antecedents/retry', params),
};

export default CriminalAntecedentService;
